export default __webpack_public_path__ + "static/16_23-5ee2104dff4962492fabf0c108f589df.png";